<ul>
    <li><a href="/">Accueil</a></li>
    <li><a class="active">Adhésion</a></li>
</ul>
